import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=4fe5c6de&scoped=true"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5c6de",
  null
  
)

export default component.exports